<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Case Management" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                        router-link.btn-default(to="/case-management") 
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                            span.pr-1 Back
            //- .box__body
            .box__body
                .container-form(action="" method="method")
                    section.group-fields.border-b
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="operation_name") Operation Name *
                            .field__form
                                input.field-style(id="operation_name" name="operation_name" type="text" v-model="operation_name" maxlength="255")
                                .error(v-if="error_operation_name !== null") {{ error_operation_name }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="location") Location *
                            .field__form
                                input.field-style(id="location" name="location" type="location" v-model="location" maxlength="255")
                                .error(v-if="error_location !== null") {{ error_location }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="assign_id") Assign To
                            .field__form
                                .relative(v-if="load_data_status_users_list === 'loading'")
                                    .field-style.flex.flex-wrap.items-center.justify-center.p-2
                                        Spinner(show="true" size="32")
                                .relative(v-else-if="users_list.data !== undefined && Object.keys(users_list.data).length > 0")
                                    multiselect(
                                        :value="completeValue",
                                        :options="filteredUsers ? filteredUsers : []",
                                        :multiple="true",
                                        placeholder="Select User",
                                        label="name",
                                        track-by="id",
                                        @input="onChange"
                                    )
                            .error(v-if="error_assign_id !== null") {{ error_assign_id }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="description") Description
                            .field__form
                                textarea.field-style(id="description" name="description" v-model="description" style="min-height: 200px;")
                                .error(v-if="error_description !== null") {{ error_description }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="status") Status *
                            .field__form.mt-2
                                .wrapper-radio.mr-8
                                    input(type="radio" name="status" value="1" v-model="status")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong Active
                                .wrapper-radio
                                    input(type="radio" name="status" value="0" v-model="status")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong Inactive
                            .error(v-if="error_status !== null") {{ error_status }}

                    .flex.items-center.justify-end.mb-8
                        //- span
                        button.btn-primary-o.btn-large(type='button' @click="reset()")
                            Strong Reset
                        button.btn-primary-o.btn-large.ml-3(type='submit' @click="submit($event, true)")
                            Strong Save &amp; Continue
                        button.btn-primary.btn-large.ml-3(type='submit' @click="submit")
                            Strong Save

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import Multiselect from 'vue-multiselect'
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'PageCaseManagementForm',
    components: {
        HeaderGlobal,
        Multiselect,
        Spinner,
    },
    data: function() {
        return {
            operation_name: '',
            location: '',
            status: '',
            assign_id: [],
            description: '',
            // error field
            error_operation_name: '',
            error_location: '',
            error_status: '',
            error_assign_id: '',
            error_description: '',
        };
    },
    computed: {
        ...mapState([
            'load_data_status_case_management_detail',
            'load_data_status_users_list',
            'case_management_detail',
            'users_list',
            // 'auth_data',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        breadcrumb() {
            let page = {
                name: 'Edit Case Management',
                url: '/case-management/'+this.id+'/edit',
            };
            if (this.route_name === 'PageCaseManagementCreate')
                page = {
                    name: 'Add Case Management',
                    url: '/case-management/create',
                };

            return [
                {
                    name: 'Case Management',
                    url: '/case-management',
                },
                page,
            ];
        },
        page_title() {
            let title = 'Edit Case Management';
            if (this.route_name === 'PageCaseManagementCreate')
                title = 'Add Case Management';
            return title;
        },
        filteredUsers() {
            if (this.users_list.data && this.users_list.data.length > 0) {
                return this.users_list.data.filter(user => {
                    return ('superadmin' != user.role.label && 'admin' != user.role.label)
                });
            }
            return []
        },
        completeValue: {
            get() {
                if (!this.assign_id) return null
                // console.log('=====onChange:get')
                // console.log(this.assign_id)
                try {
                    return this.assign_id.map(value => this.findOption(value.id)).filter(value => value.id)
                } catch (error) {
                    return null
                }
            },
            set(v) {
                // console.log('=====completeValue:set')
                // console.log(v)
                this.assign_id=v.map(value => {
                    let rObj = {}
                    rObj['id'] = value.id
                    return rObj
                })
            }
        },
    },
    watch: {
        route_name() {
            this.getData();
        },
        breadcrumb() {},
        page_title() {},
        // form data
        case_management_detail(newData) {
            this.operation_name = (newData.operation_name ? newData.operation_name : '');
            this.location = (newData.location ? newData.location : '');
            this.assign_id = (newData.assign_id && newData.assign_id ? newData.assign_id : '');
            this.status = (newData.status ? (newData.status.toLowerCase() === 'active' ? '1' : '0') : '');
            this.description = (newData.description ? newData.description : '');
        },

        operation_name() {},
        location() {},
        // load_data_status_users_list(newData) {
        //     if (newData === 'loading') {
        //         this.showLoading(true);
        //     } else {
        //         this.showLoading(false);
        //     }
        // },
        assign_id() {},
        status() {},
        description() {},
    },
    methods: {
        getData() {
            // console.log('=================== getData() route on roles form')

            this.operation_name = '';
            this.location = '';
            this.status = '';
            this.assign_id = [];
            this.description = '';

            this.error_operation_name = '';
            this.error_location = '';
            this.error_status = '';
            this.error_assign_id = '';
            this.error_description = '';
            
            // get client list
            if (this.route_name === 'PageCaseManagementEdit' || this.route_name === 'PageCaseManagementCreate') {

                // temporary
                // this.$store.dispatch('getClientsList', [100, 1]);

                // after client_id is not used
                this.$store.dispatch('getUsersList', [100, 1]);
            }

            if (this.route_name === 'PageCaseManagementEdit') {
                // console.log(this.id);

                // for dispatch get data

                this.showLoading(true);

                this.$store.dispatch('getCaseManagementDetail', [this.id])
                .then((resp) => {
                    if (resp === 'success') {

                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });

            } else {
                if (this.route_name === 'PageCaseManagementCreate')
                    this.$store.commit('setCaseManagementDetail', {});
            }
        },
        changeImgAvatar(e) {
            const file = e.target.files[0];
            this.ImgAvatar = URL.createObjectURL(file);
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    if (this.route_name === 'PageCaseManagementCreate') {
                        this.operation_name = '';
                        this.location = '';
                        this.status = '';
                        this.assign_id = [];
                        this.description = '';

                        this.error_operation_name = '';
                        this.error_location = '';
                        this.error_status = '';
                        this.error_assign_id = '';
                        this.error_description = '';
                    } else {
                        this.getData();
                    }
                }
            });
        },
        submit(e, save_continue=false){
            e.preventDefault();
            // console.log('=================== submit() route on roles form')
            // console.log(e);

            // console.log([this.operation_name, this.location, this.assign_id, this.status, this.description]);
            // this.getData();

            this.showLoading(true);

            this.error_operation_name = '';
            this.error_location = '';
            this.error_status = '';
            this.error_assign_id = '';
            this.error_description = '';


            // validation
            if (this.operation_name.length==0 || this.location.length==0 || this.status.length==0) {//this.assign_id.length==0 ||

                this.error_operation_name = (this.operation_name.length==0 ? 'Field operation name is required.' : '');
                this.error_location = (this.location.length==0 ? 'Field location is required.' : '');
                this.error_status = (this.status.length==0 ? 'Field status is required.' : '');
                // this.error_assign_id = (this.assign_id.length==0 ? 'Field assign is required.' : '');


                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Name, location, role'+ (this.route_name === 'PageCaseManagementCreate' ? ', status' : ', & status' ) +' is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.operation_name.length>255 || this.location.length>255) {

                this.error_operation_name = (this.operation_name.length>255 ? 'Field operation name is not more than 255 characters.' : '');
                this.error_location = (this.location.length>255 ? 'Field location is not more than 255 characters.' : '');
                // this.error_status = (this.status.length>255 ? 'Field status is not more than 255 characters.' : '');
                // this.error_assign_id = (this.assign_id.length>255 ? 'Field role is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Name, location is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            if (this.route_name === 'PageCaseManagementCreate') {

                this.$store.dispatch('getCaseManagementCreate', [this.operation_name, this.location, [JSON.stringify(this.assign_id)], this.status, this.description])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageCaseManagementIndex' });
                        if (save_continue === false) {
                            this.$router.push('/case-management');
                        } else {
                            this.$router.push('/case-management/'+ resp.data.data.id +'/edit');
                        }

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                    } else {
                        
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_operation_name = (resp.data.message.errors.operation_name ? resp.data.message.errors.operation_name : '');
                            this.error_location = (resp.data.message.errors.location ? resp.data.message.errors.location : '');
                            this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_assign_id = (resp.data.message.errors.assign_id ? resp.data.message.errors.assign_id : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });

            // PageCaseManagementEdit
            } else {

                this.$store.dispatch('getCaseManagementUpdate', [this.id, this.operation_name, this.location, [JSON.stringify(this.assign_id)], this.status, this.description])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageCaseManagementIndex' });
                        if (save_continue === false)
                            this.$router.push('/case-management');

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_operation_name = (resp.data.message.errors.operation_name ? resp.data.message.errors.operation_name : '');
                            this.error_location = (resp.data.message.errors.location ? resp.data.message.errors.location : '');
                            this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_assign_id = (resp.data.message.errors.assign_id ? resp.data.message.errors.assign_id : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
        findOption(value) {
            // console.log('=====findOption')
            // console.log(value)
            const opt = this.filteredUsers
            return opt.find(option => option['id'] === value)
        },
        onChange(value) {
          this.completeValue = value
        },
    },
    mounted() {
        // console.log('=================== mounted on case management form')
        this.getData();
    },
   
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="sass">

.field--search
    input
        min-width: 320px
    svg
        width: 24px
        height: 24px
        stroke: #a0aec0

// custom css from table dynamic pagination
.table-pagination.list-users
    padding-top: 15px

.error 
    color: red

</style>
